/**
 * Generated by orval 🍺
 * Do not edit manually.
 * AssetManagement
 * OpenAPI spec version: vbeta
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

export interface AssetHyperlinkProjection {
  id?: string;
  name: string;
  hyperlinkUrl: string;
  /** @nullable */
  hyperlinkType?: string | null;
  /** @nullable */
  description?: string | null;
}

export interface AssetLifecycle {
  /** @nullable */
  dateInUse?: string | null;
  /** @nullable */
  dateOutOfUse?: string | null;
}

export interface ThirdPartyInformation {
  /** @nullable */
  thirdPartyId?: string | null;
  /** @nullable */
  contractId?: string | null;
}

export interface OwnershipInformation {
  /** @nullable */
  ownerId?: string | null;
  owningOrganizationId?: string;
}

export interface AssetOverview {
  guid?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  reference?: number | string;
  name?: string;
  /** @nullable */
  description?: string | null;
  lifecycle?: AssetLifecycle;
  thirdPartyInformation?: ThirdPartyInformation;
  ownershipInformation?: OwnershipInformation;
}

export interface AssetPermissions {
  permissions?: string[];
}

export interface AssetProjection {
  guid?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  version?: number | string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  reference?: number | string;
  name: string;
  /** @nullable */
  description?: string | null;
  lifecycle: AssetLifecycle;
  thirdPartyInformation: ThirdPartyInformation;
  ownershipInformation: OwnershipInformation;
  hyperlinks?: AssetHyperlinkProjection[];
}

export interface AttachAssetHyperlinkRequest {
  name: string;
  hyperlinkUrl: string;
  /** @nullable */
  hyperlinkType: string | null;
  /** @nullable */
  description: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  version: number | string;
}

export interface DeleteAssetHyperlinkRequest {
  assetId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  version: number | string;
}

export interface EditAssetHyperlinkRequest {
  assetId: string;
  name: string;
  hyperlinkUrl: string;
  /** @nullable */
  hyperlinkType: string | null;
  /** @nullable */
  description: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  version: number | string;
}

export interface RegisterAssetRequest {
  assetName: string;
  /** @nullable */
  description: string | null;
  organizationId: string;
  /** @nullable */
  ownerId: string | null;
  lifecycle: AssetLifecycle;
}

export interface RegisterOwnershipRequest {
  owningOrganizationId: string;
  /** @nullable */
  ownerId: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  version: number | string;
}

export interface UpdateAssetLifecycleRequest {
  /** @nullable */
  dateInUse: string | null;
  /** @nullable */
  dateOutOfUse: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  version: number | string;
}

export interface UpdateAssetMetaDataRequest {
  assetName: string;
  /** @nullable */
  description: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  version: number | string;
  /** @nullable */
  thirdPartyId: string | null;
  /** @nullable */
  contractId: string | null;
}

export type GetListVbetaParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number | string;
};

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class AssetManagementService {
  private readonly http = inject(HttpClient);
 vbetaRegisterOwnership<TData = AssetProjection>(assetId: string,
    registerOwnershipRequest: RegisterOwnershipRequest, options?: HttpClientBodyOptions): Observable<TData>;
 vbetaRegisterOwnership<TData = AssetProjection>(assetId: string,
    registerOwnershipRequest: RegisterOwnershipRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 vbetaRegisterOwnership<TData = AssetProjection>(assetId: string,
    registerOwnershipRequest: RegisterOwnershipRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  vbetaRegisterOwnership<TData = AssetProjection>(
    assetId: string,
    registerOwnershipRequest: RegisterOwnershipRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/${assetId}/ownership`,
      registerOwnershipRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/${assetId}/ownership`,
      registerOwnershipRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/${assetId}/ownership`,
      registerOwnershipRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 vbetaUpdateAssetMetaData<TData = AssetProjection>(assetId: string,
    updateAssetMetaDataRequest: UpdateAssetMetaDataRequest, options?: HttpClientBodyOptions): Observable<TData>;
 vbetaUpdateAssetMetaData<TData = AssetProjection>(assetId: string,
    updateAssetMetaDataRequest: UpdateAssetMetaDataRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 vbetaUpdateAssetMetaData<TData = AssetProjection>(assetId: string,
    updateAssetMetaDataRequest: UpdateAssetMetaDataRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  vbetaUpdateAssetMetaData<TData = AssetProjection>(
    assetId: string,
    updateAssetMetaDataRequest: UpdateAssetMetaDataRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/${assetId}`,
      updateAssetMetaDataRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/${assetId}`,
      updateAssetMetaDataRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/${assetId}`,
      updateAssetMetaDataRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getAssetByIdVbeta<TData = AssetProjection>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 getAssetByIdVbeta<TData = AssetProjection>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getAssetByIdVbeta<TData = AssetProjection>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getAssetByIdVbeta<TData = AssetProjection>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/asset-management/vbeta/assets/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/asset-management/vbeta/assets/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/asset-management/vbeta/assets/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getListVbeta<TData = AssetOverview[]>(params?: GetListVbetaParams, options?: HttpClientBodyOptions): Observable<TData>;
 getListVbeta<TData = AssetOverview[]>(params?: GetListVbetaParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getListVbeta<TData = AssetOverview[]>(params?: GetListVbetaParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getListVbeta<TData = AssetOverview[]>(
    params?: GetListVbetaParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/asset-management/vbeta/assets`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/asset-management/vbeta/assets`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/asset-management/vbeta/assets`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 registerAssetVbeta<TData = AssetProjection>(registerAssetRequest: RegisterAssetRequest, options?: HttpClientBodyOptions): Observable<TData>;
 registerAssetVbeta<TData = AssetProjection>(registerAssetRequest: RegisterAssetRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 registerAssetVbeta<TData = AssetProjection>(registerAssetRequest: RegisterAssetRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  registerAssetVbeta<TData = AssetProjection>(
    registerAssetRequest: RegisterAssetRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/asset-management/vbeta/assets`,
      registerAssetRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/asset-management/vbeta/assets`,
      registerAssetRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/asset-management/vbeta/assets`,
      registerAssetRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getPermissionsVbeta<TData = AssetPermissions>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 getPermissionsVbeta<TData = AssetPermissions>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getPermissionsVbeta<TData = AssetPermissions>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getPermissionsVbeta<TData = AssetPermissions>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/asset-management/vbeta/assets/${id}/permissions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/asset-management/vbeta/assets/${id}/permissions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/asset-management/vbeta/assets/${id}/permissions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 vbetaUpdateAssetLifecycle<TData = AssetProjection>(assetId: string,
    updateAssetLifecycleRequest: UpdateAssetLifecycleRequest, options?: HttpClientBodyOptions): Observable<TData>;
 vbetaUpdateAssetLifecycle<TData = AssetProjection>(assetId: string,
    updateAssetLifecycleRequest: UpdateAssetLifecycleRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 vbetaUpdateAssetLifecycle<TData = AssetProjection>(assetId: string,
    updateAssetLifecycleRequest: UpdateAssetLifecycleRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  vbetaUpdateAssetLifecycle<TData = AssetProjection>(
    assetId: string,
    updateAssetLifecycleRequest: UpdateAssetLifecycleRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/${assetId}/lifecycle`,
      updateAssetLifecycleRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/${assetId}/lifecycle`,
      updateAssetLifecycleRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/${assetId}/lifecycle`,
      updateAssetLifecycleRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 attachAssetHyperlinkVbeta<TData = AssetProjection>(assetId: string,
    attachAssetHyperlinkRequest: AttachAssetHyperlinkRequest, options?: HttpClientBodyOptions): Observable<TData>;
 attachAssetHyperlinkVbeta<TData = AssetProjection>(assetId: string,
    attachAssetHyperlinkRequest: AttachAssetHyperlinkRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 attachAssetHyperlinkVbeta<TData = AssetProjection>(assetId: string,
    attachAssetHyperlinkRequest: AttachAssetHyperlinkRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  attachAssetHyperlinkVbeta<TData = AssetProjection>(
    assetId: string,
    attachAssetHyperlinkRequest: AttachAssetHyperlinkRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/asset-management/vbeta/assets/${assetId}/add/hyperlink`,
      attachAssetHyperlinkRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/asset-management/vbeta/assets/${assetId}/add/hyperlink`,
      attachAssetHyperlinkRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/asset-management/vbeta/assets/${assetId}/add/hyperlink`,
      attachAssetHyperlinkRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteAssetHyperlinkVbeta<TData = AssetProjection>(hyperlinkId: string,
    deleteAssetHyperlinkRequest: DeleteAssetHyperlinkRequest, options?: HttpClientBodyOptions): Observable<TData>;
 deleteAssetHyperlinkVbeta<TData = AssetProjection>(hyperlinkId: string,
    deleteAssetHyperlinkRequest: DeleteAssetHyperlinkRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteAssetHyperlinkVbeta<TData = AssetProjection>(hyperlinkId: string,
    deleteAssetHyperlinkRequest: DeleteAssetHyperlinkRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteAssetHyperlinkVbeta<TData = AssetProjection>(
    hyperlinkId: string,
    deleteAssetHyperlinkRequest: DeleteAssetHyperlinkRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/asset-management/vbeta/assets/hyperlinks/${hyperlinkId}`,{body: deleteAssetHyperlinkRequest,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }}
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/asset-management/vbeta/assets/hyperlinks/${hyperlinkId}`,{body: deleteAssetHyperlinkRequest,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }}
    );
    }

    return this.http.delete<TData>(
      `/api/asset-management/vbeta/assets/hyperlinks/${hyperlinkId}`,{body: deleteAssetHyperlinkRequest,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }}
    );
  }

 editAssetHyperlinkVbeta<TData = AssetProjection>(hyperlinkId: string,
    editAssetHyperlinkRequest: EditAssetHyperlinkRequest, options?: HttpClientBodyOptions): Observable<TData>;
 editAssetHyperlinkVbeta<TData = AssetProjection>(hyperlinkId: string,
    editAssetHyperlinkRequest: EditAssetHyperlinkRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 editAssetHyperlinkVbeta<TData = AssetProjection>(hyperlinkId: string,
    editAssetHyperlinkRequest: EditAssetHyperlinkRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  editAssetHyperlinkVbeta<TData = AssetProjection>(
    hyperlinkId: string,
    editAssetHyperlinkRequest: EditAssetHyperlinkRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/hyperlinks/${hyperlinkId}`,
      editAssetHyperlinkRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/hyperlinks/${hyperlinkId}`,
      editAssetHyperlinkRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/asset-management/vbeta/assets/hyperlinks/${hyperlinkId}`,
      editAssetHyperlinkRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

};
